<template>
<div class="RedeemCodeBank">
    <div class="bgc box-shadow title-box flexbetween">
        <div class="classes blod">{{param.name}}</div>
        <div class="tc-blue cursor" @click="cancel">返回列表</div>
    </div>
    <div class="padding-20 bgc box-shadow">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleAdd" v-if="param.status==1">添加库存</el-button>
            <el-button type="primary" @click="handleExport" plain>导出</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.exstatus" placeholder="兑换状态" class="condition">
                <el-option v-for="(obj,i) in statusList" :key="i" :label="obj.name" :value="obj.code"></el-option>
            </el-select>
            <el-select v-model="param.sendstatus" placeholder="发放状态" class="condition">
                <el-option v-for="(obj,i) in sendstatusList" :key="i" :label="obj.name" :value="obj.code"></el-option>
            </el-select>
            <el-input v-model="param.codevalue" placeholder="请输入关键字" class="condition key" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="codevalue" label="兑换码" class-name="title" width="120px"></el-table-column>
            <el-table-column prop="statusname" label="发放状态" width="120px" class-name="tc" label-class-name="tc">
                <template slot-scope="scope"><div>{{scope.row.sendstatusname}}</div></template>
            </el-table-column>
            <el-table-column prop="statusname" label="兑换状态" width="120px" class-name="tc" label-class-name="tc">
                <template slot-scope="scope"><div>{{scope.row.exstatusname}}</div></template>
            </el-table-column>
            <el-table-column prop="datetime" label="创建时间" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="sendtime" label="发放时间" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="extime" label="兑换时间" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="exorderno" label="订单号" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="excustomername" label="兑换人" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column label="操作" width="180px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr" v-if="[0, 1].indexOf(param.status)>-1">
                        <span class="separator-btn" v-if="[0].indexOf(scope.row.sendstatus)>-1 && [0].indexOf(scope.row.exstatus)>-1">
                            <el-button @click.stop="handleDirectGrant(scope.row)" type="text" size="small">直接发放</el-button>
                        </span>
                        <span class="separator-btn" v-if="[0].indexOf(scope.row.sendstatus)>-1 && [0].indexOf(scope.row.exstatus)>-1">
                            <el-button @click.stop="handleIndirectGrant(scope.row)" type="text" size="small">短信发放</el-button>
                        </span>
                        <span class="separator-btn" v-if="[0].indexOf(scope.row.exstatus)>-1">
                            <el-button @click.stop="handleDel(scope.row)" type="text" size="small">作废</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pagesize" :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
    </div>
    <addBankDialog ref="addBankDialog" @refresh="_getList"></addBankDialog>
    <grantCodeDialog ref="grantCodeDialog" @refresh="_getList"></grantCodeDialog>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {getAsseTredeemCodeDetailList, uploadTredeemCodeBySendstatus, uploadTredeemCodeByExstatus, exportAsseTredeemCodeDetailList, getAsseTredeemCodeInfo} from 'api/operateToolApi'
import {dateFormat} from 'common/js/tools'
import AddBankDialog from 'views/operateTool/redeemCode/components/addBankDialog.vue'
import GrantCodeDialog from 'views/operateTool/redeemCode/components/grantCodeDialog.vue'
export default {
    name: 'RedeemCodeBank',
    data() {
        return {
            tableData: [],
            total: 0,
            page: {
                page: 1,
                pagesize: 10,
                pageCount: 0
            },
            statusList: [{code: '', name: '兑换状态'},{code: '0', name: '未兑换'},{code: '10', name: '已兑换'},{code: '100', name: '已作废'}],
            sendstatusList: [{code: '', name: '发放状态'},{code: '0', name: '未发放'},{code: '1', name: '已发放'}],
            param: {
                codeid: this.$route.query.codeid ? this.$route.query.codeid: '',
                name: this.$route.query.name ? this.$route.query.name: '' ,
                status: this.$route.query.status ? this.$route.query.status: '' , // 1进行中、0未开始、10已结束、100已删除
                kmcname: '',
                sendstatus: '', //  发放状态：0否 1是
                exstatus: '', // 兑换状态：0未兑换 10已兑换 100已作废
                codevalue: '',  // 兑换码值
            }
        }
    },
    mounted() {
        if (this.param.codeid) {
            this._getList()
            this._getView()
        }
    },
    methods: {
        cancel() {
            this.$router.back()
        },
        handleAdd() {
            this.$refs.addBankDialog.openDialog(this.param)
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleDirectGrant(row) {
            this.$confirm('确认直接发放该兑换码？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this._grant(row)
            }).catch(() => {})
        },
        handleIndirectGrant(row) {
            this.$refs.grantCodeDialog.openDialog(row, this.param)
        },
        handleDel(row) {
            this.$confirm('确认作废该兑换码？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this._del(row)
            }).catch(() => {})
        },
        handleExport(row) {
            this.setLoading(true)
            exportAsseTredeemCodeDetailList({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '兑换码库' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _del(row) {
            this.setLoading(true)
            uploadTredeemCodeByExstatus ({
                data: {codedetailid: row.codedetailid},
                success: data => {
                    this.$message.success('直接发放成功！')
                    this.setIsRefresh(1)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _grant(row) {
            this.setLoading(true)
            uploadTredeemCodeBySendstatus ({
                data: {codedetailid: row.codedetailid},
                success: data => {
                    this.$message.success('直接发放成功！')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getAsseTredeemCodeDetailList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.datacount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            getAsseTredeemCodeInfo({
                data: this.param,
                success: data => {
                    this.param.status = data.data.status
                    this.param.name = data.data.name
                    this.param.kmcname = data.data.kmcname
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setIsRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        GrantCodeDialog, AddBankDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.RedeemCodeBank {
    .title-box {
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        margin-bottom: 30px;
        .classes {
            margin-bottom: 0;
        }
        .el-input__icon {
            line-height: 1;
        }
    }
}
</style>
